export default  {
  parent: {

  },
  teacher: {
    teacherInviteAdmin: false
  },
  admins: {

  }
}
